const DATA_URL = "https://portfolio-2.s3.ap-south-1.amazonaws.com/data.json";

export const fetchAllData = async () => {
  const data = await fetch(DATA_URL, {
    method: "get",
    mode: "cors",
  });
  const response = await data.json();
  return response;
};
